import { render, staticRenderFns } from "./ApckDraggableTable.vue?vue&type=template&id=0c6f7f02&scoped=true"
import script from "./ApckDraggableTable.vue?vue&type=script&lang=js"
export * from "./ApckDraggableTable.vue?vue&type=script&lang=js"
import style0 from "./ApckDraggableTable.vue?vue&type=style&index=0&id=0c6f7f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f7f02",
  null
  
)

export default component.exports